
import api from '../api';
import axios from 'axios';

export default {
    GET_EMAIL_BY_DATE: (query, selectedBoardId) => {
        return new Promise((resolve, reject) => {
            axios
                .get(process.env.REACT_APP_BACKEND_URL + api.Email.GET_EMAIL_BY_DATE(query, selectedBoardId))
                .then((response) => resolve(response))
                .catch((err) => reject(err));
        });
    },

    GET_EMAIL_BY_SELECTED_USER: (query) => {
        return new Promise((resolve, reject) => {
            axios
                .get(process.env.REACT_APP_BACKEND_URL + api.Email.GET_EMAIL_BY_SELECTED_USER(query))
                .then((response) => resolve(response))
                .catch((err) => reject(err));
        });
    },
    UPDATED_EMAIL_FOR_TASK: (id) => {
        return new Promise((resolve, reject) => {
            axios
                .put(
                    `${process.env.REACT_APP_BACKEND_URL}+ api.Email.UPDATED_EMAIL_FOR_TASK${id}`,
                )
                .then((response) => resolve(response))
                .catch((err) => reject(err));
        });
    },

    Get_The_Linked_Email: (urlParams) => {
        return new Promise((resolve, reject) => {
            axios
                .get(process.env.REACT_APP_BACKEND_URL + api.Email.Get_The_Linked_Email(urlParams))
                .then((response) => resolve(response))
                .catch((err) => reject(err));
        });
    },
    GET_ALL_CREDENTIALS_EMAIL: () => {
        return new Promise((resolve, reject) => {
            axios
                .get(process.env.REACT_APP_BACKEND_URL + api.Email.GET_ALL_CREDENTIALS_EMAIL())
                .then((response) => resolve(response))
                .catch((err) => reject(err));
        });
    },
    CreateEmailUser: (data) => {
        return new Promise((resolve, reject) => {
            axios
                .post(process.env.REACT_APP_BACKEND_URL + api.Email.CreateEmailUser(), data)
                .then((response) => resolve(response))
                .catch((err) => reject(err));
        });
    },
    updateAuthEmail: (id) => {
        return new Promise((resolve, reject) => {
            axios
                .get(process.env.REACT_APP_BACKEND_URL + api.Email.updateEmailUser(id))
                .then((response) => resolve(response))
                .catch((err) => reject(err));
        });
    },

    GET_TASK_GMAILMESSAGE_ID: (id) => {
        return new Promise((resolve, reject) => {
            axios
                .get(process.env.REACT_APP_BACKEND_URL + api.Email.GET_TASK_GMAILMESSAGE_ID(id))
                .then((response) => resolve(response))
                .catch((err) => reject(err));
        });
    },
    GET_ALL_CLIENT: () => {
        return new Promise((resolve, reject) => {
            axios
                .get(process.env.REACT_APP_BACKEND_URL + api.Email.GET_ALL_CLIENT())
                .then((response) => resolve(response))
                .catch((err) => reject(err));
        });
    },
    EMAIL_SEARCH_BY_QUERY: (emails, query) => {
        return new Promise((resolve, reject) => {
            axios
                .get(process.env.REACT_APP_BACKEND_URL + api.Email.EMAIL_SEARCH_BY_QUERY(emails, query))
                .then((response) => resolve(response))
                .catch((err) => reject(err));
        });
    },
    GET_SENT_MAIL: (page, limit, gmailUserId, search, signal) => {
        return new Promise((resolve, reject) => {
            axios
                .get(process.env.REACT_APP_BACKEND_URL + api.Email.GET_SENT_MAIL(page, limit, gmailUserId, search), { signal })
                .then((response) => resolve(response))
                .catch((err) => reject(err));
        });
    },
    UPDATE_EMAIL_SENDMAIL: (id, data) => {
        return new Promise((resolve, reject) => {
            axios
                .put(process.env.REACT_APP_BACKEND_URL + api.Email.UPDATE_EMAIL_SENDMAIL(id), data)
                .then((response) => resolve(response))
                .catch((err) => reject(err));
        });
    },
    GET_ALL_MAILS: (gmailUserId, page, limit, search, signal, falsepagination) => {
        return new Promise((resolve, reject) => {
            const query = `gmailUserId=${gmailUserId}&page=${page}&limit=${limit}&search=${search || ""}${falsepagination ? "&falsepagination=true" : ""}`;
            axios
                .get(`${process.env.REACT_APP_BACKEND_URL}/email/getAllEmails?${query}`, { signal })
                .then((response) => resolve(response))
                .catch((err) => reject(err));
        });
    },
    SYNC_OLD_MAIL: (data) => {
        return new Promise((resolve, reject) => {
            axios
                .post(process.env.REACT_APP_BACKEND_URL + api.Email.SYNC_OLD_MAIL(), data)
                .then((response) => resolve(response))
                .catch((err) => reject(err));
        });
    },
   EMAIL_UPDATEMESSAGE_READ: (id, data) => {
        return new Promise((resolve, reject) => {
            axios
                .put(process.env.REACT_APP_BACKEND_URL + api.Email.EMAIL_UPDATEMESSAGE_READ(id), data)
                .then((response) => resolve(response))
                .catch((err) => reject(err));
        });
    },
};
